import * as utils from './utils';

function printElementsForChrome (elements, styles) {
    const chromePrintTemplate = (`
        <head>
            <style>${styles}</style>
        </head>
        <body>
            ${elements.map(elemId => utils.getElement(elemId).outerHTML)}
        </body>
    `);
    const html = document.getElementsByTagName('HTML')[0];
    const printElement = document.createElement('div');
    const uniqueId = `get-info-tnc-${Math.floor(Math.random() * 20)}`;
    const originalDocumentTitle = document.title;
    // add print elements
    printElement.setAttribute('id', uniqueId);
    printElement.innerHTML = chromePrintTemplate;
    html.appendChild(printElement);
    document.title = 'Terms and Conditions';
    
    window.print();
    // remove print elements
    html.removeChild(document.getElementById(uniqueId));
    document.title = originalDocumentTitle;
} 

export function printElements(elements, styles){
    if (!!window.chrome) {
        // we're using @media print for chrome to avoid pop up off focus issues
        return printElementsForChrome(elements, styles);
    }

    const printTemplate = `<html>
        <head>
            <style>
                ${styles}
            </style>
        </head>
        <body>
            ${elements.map(elemId=>utils.getElement(elemId).outerHTML)}
        </body>
    </html>`;
    const printWindow = open('', '', 'left=0,top=0,width=1000,height=700,toolbar=0,scrollbars=0,status=0');

    printWindow.document.write(printTemplate);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};


// WEBPACK FOOTER //
// ./application/src/utilities/print.jsx